import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.boundClose = this.closeOnClickOutside.bind(this)
    this.boundEscape = this.onEscape.bind(this)
    this.boundTurbo = this.close.bind(this)

    document.addEventListener("click", this.boundClose)
    document.addEventListener("keydown", this.boundEscape)
    document.addEventListener("turbo:before-visit", this.boundTurbo)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClose)
    document.removeEventListener("keydown", this.boundEscape)
    document.removeEventListener("turbo:before-visit", this.boundTurbo)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    const btn = this.element.querySelector("button")
    const rect = btn.getBoundingClientRect()
    this.menuTarget.style.top = (rect.bottom + 8) + "px"
    this.menuTarget.style.right = (window.innerWidth - rect.right) + "px"
    this.menuTarget.classList.remove("hidden")
  }

  close() {
    this.menuTarget.classList.add("hidden")
  }

  closeOnClickOutside(event) {
    if (this.element.contains(event.target)) return
    this.close()
  }

  onEscape(event) {
    if (event.key === "Escape") this.close()
  }
}
